/**
 * Ryan O'Dowd
 * 2025-02-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  const iconWrapperStyles = {
    borderWidth: globalScale * 2,
    borderColor: colors.primary, // @TODO: different in dark mode?
    borderRadius: globalScale * 8,
    padding: 4,
  };

  return {
    container: {
      marginTop: 4,
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    textWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexShrink: 1,
    },
    titleText: {
      display: 'flex',
      color: colors.white,
      flexWrap: 'wrap',
      fontSize: globalScale * 18,
      fontFamily: fonts.primaryBold,
    },
    descriptionWrapper: {
      display: 'flex',
    },
    descriptionText: {
      display: 'flex',
      color: colors.white,
      flexWrap: 'wrap',
      fontSize: globalScale * 15,
    },
    rightActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 4,
      marginLeft: 4,
    },
    cellAndTextWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    },
    cellIconWrapper: (status) => ({
      ...iconWrapperStyles,
      borderColor: status ? colors.accent : colors.primaryDark,
    }),
    cellIcon: (status) => ({
      color: status ? colors.accent : colors.primaryDark,
    }),
    typeText: (status) => ({
      color: status ? colors.accent : colors.primaryDark,
      fontSize: globalScale * 12,
    }),
    actionsRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 8,
    },
  };
};

export default getStyles;
